import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './trash-empty-state.style';

export const TrashEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <Styled.IconContainer>
        <Icon icon={Trash2} />
      </Styled.IconContainer>
      <Styled.Title>{t('trash.empty-state-title')}</Styled.Title>
    </Styled.Container>
  );
};
